import { isBaseEntity } from '@tunasong/schemas'
import type { Entity, EntityType, Narrow } from '@tunasong/schemas'
import type { RemoteCursor } from '../editor/cursor.js'

export interface DocumentEntity extends Entity {
  /**
   * @see https://github.com/automerge/automerge
   *
   * To read it, use `Automerge.load(entity.doc)`
   * To set it, use `Automerge.save()`
   */
  doc?: string
  cursors?: Record<string, RemoteCursor>
}

const documentEntityNames = ['page', 'song'] as const
export type DocumentEntityType = Narrow<EntityType, 'page' | 'song'>

/**
 * Check whether the value is a song/page document by `type`. Persisted,
 * YDoc-backed documents from the entities API carry no `children` field
 * (content lives in the YDoc), so this must NOT require a Slate element
 * shape — `isCoreElement`'s non-empty-children demand rejected every real
 * persisted song (playlist linked-song indicator bug, 2026-06-07).
 */
export function isDocumentEntity(element?: unknown): element is DocumentEntity {
  return isBaseEntity(element) && documentEntityNames.includes(element.type as DocumentEntityType)
}
